import { IRecoleccion } from "./recoleccionActionTypes";
import { IGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { IGuiaConsultaDto } from "../../entities/guias/IGuiaConsultaDto";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { MercanciaDatosComplementarios } from "../../entities/solicitudes/MercanciaDatosComplementarios";

export const SET_GUIA_WIZARD = 'SET_GUIA_WIZARD';
export const SET_GUIA_ORIGEN = 'SET_GUIA_ORIGEN';
export const SET_GUIA_DESTINO = 'SET_GUIA_DESTINO';
export const SET_GUIA_MERCANCIAS = 'SET_GUIA_MERCANCIAS';
export const SET_GUIA_MERCANCIAS_COMPLEMENTARIAS = 'SET_GUIA_MERCANCIAS_COMPLEMENTARIAS';
export const SET_GUIA_SERVICIOS = 'SET_GUIA_SERVICIOS';
export const RESET_GUIA_NUEVA = 'RESET_GUIA_NUEVA';
export const SET_GUIA_CONSULTA = 'SET_GUIA_CONSULTA';
export const CLEAR_GUIA_CONSULTA = 'CLEAR_GUIA_CONSULTA';

interface ISetGuiaWizard {
    type: typeof SET_GUIA_WIZARD;
    wizard: IGuiaWizard;
}

interface ISetGuiaOrigen {
    type: typeof SET_GUIA_ORIGEN;
    recoleccion: IRecoleccion;
}

interface ISetGuiaDestino {
    type: typeof SET_GUIA_DESTINO;
    recoleccion: IRecoleccion;
}

interface ISetGuiaMercancias {
    type: typeof SET_GUIA_MERCANCIAS;
    mercancias: Mercancia[];
}

interface ISetGuiaMercanciasComplementarias {
    type: typeof SET_GUIA_MERCANCIAS_COMPLEMENTARIAS;
    mercanciasComplementarias: MercanciaDatosComplementarios[];
}

interface ISetGuiaServicios {
    type: typeof SET_GUIA_SERVICIOS;
    servicios: ServicioAdicional[];
}

interface IResetGuiaNueva {
    type: typeof RESET_GUIA_NUEVA;
}

interface ISetGuiaConsulta {
    type: typeof SET_GUIA_CONSULTA;
    consulta: IGuiaConsultaDto;
}

interface IClearGuiaConsulta {
    type: typeof CLEAR_GUIA_CONSULTA;
}

export type GuiaActionTypes =
    | ISetGuiaWizard
    | ISetGuiaOrigen
    | ISetGuiaDestino
    | ISetGuiaMercancias
    | ISetGuiaMercanciasComplementarias
    | ISetGuiaServicios
    | IResetGuiaNueva
    | ISetGuiaConsulta
    | IClearGuiaConsulta;
